<div class="sale-submissions-popup">
  <form
    name="saleSubmissionsForm"
    (ngSubmit)="formSubmit()"
    [formGroup]="saleBreezeUpForm"
    novalidate
  >
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Add New Breeze Date</h4>
      <div class="d-flex justify-content-end ms-auto">
        <button type="button" class="btn col-auto me-2 btn-secondary"  (click)="modal.dismiss('Cross click')"><i class="fa fa-times"></i> Cancel</button>
        <button type="submit" class="btn col-auto btn-primary"><i class="fa fa-save"></i> Save</button>
      </div>
    </div>
    <div class="modal-body">
      <div class="row mb-2">
        <div class="data-grid mt-2">
          <div class="table table-commence-days">
            <!-- Header Row -->
            <div class="row mb-2 mat-header-row h-auto">
              <div class="col-12 col-md-1">
                <label class="t-heading">Book</label>
              </div>
              <div class="col-12 col-md-1">
                <label class="t-heading">Session</label>
              </div>

              <div class="col-12 col-md-2">
                <label class="t-heading">Sale Date/Time</label>
              </div>
              <div class="col-12 col-md-1">
                <label class="t-heading">First {{ data?.lotOrHipText }}</label>
              </div>
              <div class="col-12 col-md-1">
                <label class="t-heading">Last {{ data?.lotOrHipText }}</label>
              </div>
              <div class="col-12 col-md-2">
                <label class="t-heading">Breeze Date/Time</label>
              </div>
              <div class="col-12 col-md-2">
                <label class="t-heading">X-Ray/Scope Taken</label>
              </div>
              <div class="col-12 col-md-2">
                <label class="t-heading">X-Ray/Scope Visible</label>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-md-1">
                <div class="t-data">
                  <select
                    class="form-select"
                    formControlName="bookNumber"
                    (change)="loadSessions($event)"
                    ngDefaultControl
                  >
                    <option value="null">
                      {{ "Select" }}
                    </option>
                    <option
                      *ngFor="let book of data.books"
                      value="{{ book.bookNumber }}"
                    >
                      {{ book.bookNumber }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-12 col-md-1">
                <div class="t-data">
                  <select
                    class="form-select"
                    formControlName="sessionNumber"
                    (change)="loadHips($event)"
                    ngDefaultControl
                  >
                    <option value="null">
                      {{ "Select" }}
                    </option>
                    <option
                      *ngFor="let session of currentSessions"
                      value="{{ session.sessionNumber }}"
                    >
                      {{ session.sessionNumber }}
                    </option>
                  </select>
                </div>
              </div>
              <!-- Xray scope visible -->
              <div class="col-12 col-md-2">
                <div class="input-group">
                  <input
                    type="text"
                    name="daterange"
                    *ngIf="dateFormat"
                    [start]="saleBreezeUpForm.value.saleDateTime"
                    [end]="saleBreezeUpForm.value.saleDateTime"
                    #saleDateTime
                    [format]="dateFormat"
                    (change)="onSelectDate($event, 'saleDateTime')"
                    class="form-control date-range-picker"
                    appDateTimepicker
                  />
                  <button
                    class="btn btn-outline-secondary bi bi-calendar3"
                    (click)="openDatePicker(saleDateTime)"
                    type="button"
                  >
                    <i class="fa fa-calendar"></i>
                  </button>
                </div>
              </div>
              <div class="col-12 col-md-1">
                <div class="t-data">
                  <select
                    class="form-select"
                    formControlName="minLotNumber"
                    (change)="loadMaxHips($event)"
                  >
                    <option value="null">
                      {{ "Select" }}
                    </option>
                    <option *ngFor="let hip of hipRange" value="{{ hip }}">
                      {{ hip }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-12 col-md-1">
                <div class="t-data">
                  <select class="form-select" formControlName="maxLotNumber">
                    <option value="null">
                      {{ "Select" }}
                    </option>
                    <option *ngFor="let hip of maxHips" value="{{ hip }}">
                      {{ hip }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-12 col-md-2">
                <div class="input-group">
                  <input
                    type="text"
                    name="daterange"
                    *ngIf="dateFormat"
                    [start]="saleBreezeUpForm.value.breezeDateTime"
                    [end]="saleBreezeUpForm.value.breezeDateTime"
                    #breezeDateTime
                    [format]="dateFormat"
                    (change)="onSelectDate($event, 'breezeDateTime')"
                    class="form-control date-range-picker"
                    appDateTimepicker
                  />
                  <button
                    class="btn btn-outline-secondary bi bi-calendar3"
                    (click)="openDatePicker(breezeDateTime)"
                    type="button"
                  >
                    <i class="fa fa-calendar"></i>
                  </button>
                </div>
              </div>

              <!-- Xray scope taken -->
              <div class="col-12 col-md-2">
                <div class="input-group">
                  <input
                    type="text"
                    name="daterange"
                    *ngIf="dateFormat"
                    [start]="saleBreezeUpForm.value.xrayScopeTaken"
                    [end]="saleBreezeUpForm.value.xrayScopeTaken"
                    #xrayScopeTaken
                    [format]="dateFormat"
                    (change)="onSelectDate($event, 'xrayScopeTaken')"
                    class="form-control date-range-picker"
                    appDateTimepicker
                  />
                  <button
                    class="btn btn-outline-secondary bi bi-calendar3"
                    (click)="openDatePicker(xrayScopeTaken)"
                    type="button"
                  >
                    <i class="fa fa-calendar"></i>
                  </button>
                </div>
              </div>
              <!-- Xray scope visible -->
              <div class="col-12 col-md-2">
                <div class="input-group">
                  <input
                    type="text"
                    name="daterange"
                    *ngIf="dateFormat"
                    [start]="saleBreezeUpForm.value.xrayScopeVisible"
                    [end]="saleBreezeUpForm.value.xrayScopeVisible"
                    #xrayScopeVisible
                    [format]="dateFormat"
                    (change)="onSelectDate($event, 'xrayScopeVisible')"
                    class="form-control date-range-picker"
                    appDateTimepicker
                  />
                  <button
                    class="btn btn-outline-secondary bi bi-calendar3"
                    (click)="openDatePicker(xrayScopeVisible)"
                    type="button"
                  >
                    <i class="fa fa-calendar"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
